<template>
  <div class="form-wrapper">
    <ValidationObserver v-slot="{ handleSubmit, invalid  }">
      <form @submit.prevent="handleSubmit(validateFormData)">
        <slot/>
        <slot name="buttonSubmit" :invalid="invalid"></slot>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
  export default {
    name: 'FormWrapper',
    props: {
      postFormData: {
        required: true
      }
    },
    computed: {
      formData: function () {
        return this.$store.getters.getFormData;
      }
    },
    methods: {
      validateFormData: function () {
        // send the data to the parent
        this.$props.postFormData(this.formData);
      }
    }
  }
</script>

<style lang="scss">
  @import "../../assets/css/base.variables";
  @import "../../assets/css/base.mixins";

  $backgroundColor: white;
  $titleColor: $black-light;
  $textColor: black;
  $textColorPlaceholder: #9b9b9b;
  $placeholderColor: #757575;
  $formInputBackgroundColor: white;

  /* form elements */
  input, select, textarea {
    width: 100%;
    font-family: 'Source Sans Pro', sans-serif;

    @include placeholder {
      color: $placeholderColor;
      font-size: 16px;
      font-family: 'Source Sans Pro', sans-serif;
    }

    &:focus {
      outline: none;
    }
  }

  label {
    width: 100%;
  }

  input {
    max-width: 550px;
    width: 100%;
    -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
    -moz-box-sizing: border-box;    /* Firefox, other Gecko */
    box-sizing: border-box;         /* Opera/IE 8+ */

    &::-webkit-calendar-picker-indicator {
      display: none;
    }
  }

  .form-input-title {
    color: $titleColor;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    margin-bottom: 8px;
    text-align: left;
  }

  .form-input-title-align {
    @extend .form-input-title;
    margin-bottom: 20px;
    padding-left: 0;
  }

  .form-input {
    background-color: $formInputBackgroundColor;
    border: none;
    border-radius: 8px;
    color: $textColor;
    font-size: 14px;
    height: 50px;
    margin-bottom: 15px;
    padding-left: 15px;

    &::placeholder {
      color: $textColorPlaceholder;
      font-size: 14px;
      opacity: 0.7;
    }
  }

  /* texts */
  .text-error {
    margin-top: 5px;
    color: $red-main;
    font-weight: 600;
    text-align: left;
  }

  .text-input-error {
    margin-top: 5px;
    color: $red-main;
    text-align: left;
  }

  .text-error-field {
    padding: 0 10px 10px 0;
    color: $red-main;
    font-weight: bold;
    font-size: 16px;
    text-align: left;
  }

  .field-error {
    border: 1px solid $red-main;
  }

  @media screen and (min-width: $screen-md) {
    .form-input {
      font-size: 16px;

      &::placeholder {
        font-size: 16px;
      }
    }
  }
</style>
